import { toLocalISODate } from './selfiePeriod';

/** Ciclo em aberto com data de fecho hoje ou já passada. */
export function isCycleCloseDue(currentCycle, referenceDate = new Date()) {
  if (!currentCycle?.isCurrent || !currentCycle?.end) return false;
  const today = toLocalISODate(referenceDate);
  return today >= currentCycle.end;
}

export function isCycleCloseOverdue(currentCycle, referenceDate = new Date()) {
  if (!currentCycle?.isCurrent || !currentCycle?.end) return false;
  const today = toLocalISODate(referenceDate);
  return today > currentCycle.end;
}
